/*
 * Carousel behavior for the "GLOON - Reviews" section.
 *
 * The scroll itself (touch swipe, momentum, snap-to-card) is 100% native
 * CSS (overflow-x + scroll-snap) — no JS involved. This file only handles
 * what has no native CSS equivalent: moving the scroll position on
 * prev/next click, moving it on pagination-dot click, and keeping the
 * active dot in sync with whichever card is currently in view.
 */
document.querySelectorAll('[data-gloon-reviews-track]').forEach(function (track) {
  var wrap = track.closest('.gloon-reviews__carousel-wrap');
  if (!wrap) return;

  var container = wrap.closest('.gloon-reviews__container') || wrap.parentElement;
  var prevBtn = wrap.querySelector('[data-gloon-reviews-prev]');
  var nextBtn = wrap.querySelector('[data-gloon-reviews-next]');
  var pagination = container ? container.querySelector('[data-gloon-reviews-pagination]') : null;
  var dots = pagination ? Array.prototype.slice.call(pagination.querySelectorAll('[data-gloon-reviews-dot]')) : [];
  var slides = Array.prototype.slice.call(track.querySelectorAll('[data-gloon-reviews-slide]'));

  function slideStep() {
    var first = slides[0];
    if (!first) return track.clientWidth;
    var style = window.getComputedStyle(track);
    var gap = parseFloat(style.columnGap || style.gap || '0') || 0;
    return first.getBoundingClientRect().width + gap;
  }

  if (prevBtn) {
    prevBtn.addEventListener('click', function () {
      track.scrollBy({ left: -slideStep(), behavior: 'smooth' });
    });
  }

  if (nextBtn) {
    nextBtn.addEventListener('click', function () {
      track.scrollBy({ left: slideStep(), behavior: 'smooth' });
    });
  }

  track.addEventListener('keydown', function (event) {
    if (event.key === 'ArrowRight') {
      event.preventDefault();
      track.scrollBy({ left: slideStep(), behavior: 'smooth' });
    } else if (event.key === 'ArrowLeft') {
      event.preventDefault();
      track.scrollBy({ left: -slideStep(), behavior: 'smooth' });
    }
  });

  dots.forEach(function (dot, index) {
    dot.addEventListener('click', function () {
      var target = slides[index];
      if (!target) return;
      track.scrollTo({ left: target.offsetLeft - track.offsetLeft, behavior: 'smooth' });
    });
  });

  if (dots.length && slides.length && 'IntersectionObserver' in window) {
    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          var index = slides.indexOf(entry.target);
          if (index === -1) return;
          dots.forEach(function (dot, dotIndex) {
            var active = dotIndex === index;
            dot.classList.toggle('is-active', active);
            dot.setAttribute('aria-selected', active ? 'true' : 'false');
          });
        });
      },
      { root: track, threshold: 0.6 }
    );

    slides.forEach(function (slide) {
      observer.observe(slide);
    });
  }
});
